import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
} from 'react';

export interface ModalDataProp {
  modal: string;
  metadata: any;
}

interface ModalContextProps {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  modal: ModalDataProp;
  setModal: Dispatch<SetStateAction<ModalDataProp>>;
  modalComponent: ReactNode;
}

const ModalContext = createContext<ModalContextProps>({
  openModal: false,
  setOpenModal: () => {},
  modal: { modal: '', metadata: {} },
  setModal: () => {},
  modalComponent: null,
});

export const useModalContext = () => useContext(ModalContext);

export default ModalContext;
